import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import AutoWeight from '../../../../components/auto-weight';
import { ManualWeightContainer } from './manual-weight/container';
import { ScaleWeightDisplay } from './scale-weight-display';
import { useFulfillmentPlannerContext } from '../../../../fulfillment-planner/context';
import { ScanToVerifyReader } from '../../../../store/scan-to-print/scan-to-verify-reader';
import { ScanToPrintReader } from '../../../../store/scan-to-print/scan-to-print-reader';
import { usePackagesWeightInSellerUnit } from '../../../../hooks/use-packages-weight-in-seller-unit';

import { useAutoScale } from '../../../auto-scale-provider';

export const ScanToPrintWeight = ({ fulfillmentPlanId = null, shouldUseScale = false }) => {
  const { packages, onWeightAndDimensionsChange } = useFulfillmentPlannerContext();
  const { value: weight, unit } = usePackagesWeightInSellerUnit(packages);
  const isMultiPackage = packages.length > 1;

  const inVerifyMode = useSelector((state) => new ScanToPrintReader({ state }).inVerifyMode);
  const isFulfillmentPlanVerified = useSelector((state) =>
    new ScanToVerifyReader({ state }).isFulfillmentPlanVerified({
      fulfillmentPlanId,
    }),
  );
  const { autoReadScale$, scale } = useAutoScale();

  const shouldReadFromScale = !inVerifyMode || isFulfillmentPlanVerified;
  const isAutoReadDisabled = !shouldReadFromScale || isMultiPackage;
  const onWeightOrDimsChange = useCallback(
    (value) => {
      if (value.weight || value.dimensions) {
        onWeightAndDimensionsChange(value.weight, value.dimensions);
      }
    },
    [onWeightAndDimensionsChange],
  );

  return scale?.id && shouldUseScale ? (
    <AutoWeight autoReadScale$={autoReadScale$} isDisabled={isAutoReadDisabled} onScaleRead={onWeightOrDimsChange} weight={weight}>
      {(w) => <ScaleWeightDisplay unit={unit} weight={w} />}
    </AutoWeight>
  ) : (
    <ManualWeightContainer disabled={isMultiPackage} onChange={onWeightAndDimensionsChange} unit={unit} weight={weight} />
  );
};

ScanToPrintWeight.propTypes = {
  fulfillmentPlanId: PropTypes.string,
  shouldUseScale: PropTypes.bool,
};
